import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../common/Button";
import { AddBuildingForm } from "./AddBuildingForm";
import { setupDevicesPath } from "./setupRoutes";
import { SetupLayout } from "./SetupLayout";
import { useBreedingBuildings } from "./useBreedingBuildings";

// Clés passées en props à SetupLayout, invisibles du parser sans ces marqueurs.
// i18n.t("setup-buildings-title")
// i18n.t("setup-buildings-intro")
export const SetupBuildingsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const breedingId = Number(useParams().breedingId);

  const { buildings, reload } = useBreedingBuildings(breedingId);

  return (
    <SetupLayout
      step={2}
      breedingId={breedingId}
      titleKey="setup-buildings-title"
      introKey="setup-buildings-intro"
    >
      <AddBuildingForm
        breedingId={breedingId}
        buildings={buildings}
        onAdded={reload}
      />

      <div className="mt-6">
        <Button
          size="full"
          disabled={buildings.length === 0}
          actif={buildings.length > 0}
          onClick={() => navigate(setupDevicesPath(breedingId))}
        >
          {t("setup-next")}
        </Button>
        {buildings.length === 0 && (
          <p className="mt-2 text-sm text-grey-readable text-center">
            {t("setup-buildings-need-one")}
          </p>
        )}
      </div>
    </SetupLayout>
  );
};
